import { SVGProps } from 'react';

function ChevronDown(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={15}
      height={8}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.458.917 7.404 6.971a.423.423 0 0 1-.6 0L.75.917"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

ChevronDown.defaultProps = {
  role: 'graphics-document',
};

export default ChevronDown;
